import { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from '@/components/ui/command';
import { Tag, Calendar } from 'lucide-react';
import { searchPosts } from '../data/posts';

export default function SearchModal({ open, onClose }) {
  const [query, setQuery] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    if (!open) {
      setQuery('');
    }
  }, [open]);

  const results = useMemo(() => {
    if (!query || query.length < 2) return [];
    return searchPosts(query);
  }, [query]);

  const handleSelect = (slug) => {
    onClose();
    navigate(`/posts/${slug}`);
  };

  return (
    <CommandDialog open={open} onOpenChange={onClose}>
      <CommandInput
        data-testid="search-input"
        placeholder="Search posts by title, category, tag..."
        value={query}
        onValueChange={setQuery}
      />
      <CommandList>
        {query.length >= 2 && results.length === 0 && (
          <CommandEmpty>No results for &ldquo;{query}&rdquo;</CommandEmpty>
        )}
        {results.length > 0 && (
          <CommandGroup heading="Posts">
            {results.map(post => (
              <CommandItem
                key={post.id}
                data-testid={`search-result-${post.slug}`}
                value={post.title}
                onSelect={() => handleSelect(post.slug)}
                className="flex flex-col items-start gap-1 py-3 cursor-pointer"
              >
                <span className="font-medium text-sm">{post.title}</span>
                <span className="flex items-center gap-3 text-xs text-muted-foreground">
                  <span className="flex items-center gap-1">
                    <Tag className="h-3 w-3" />{post.category}
                  </span>
                  <span className="flex items-center gap-1">
                    <Calendar className="h-3 w-3" />
                    {new Date(post.created_at).toLocaleDateString()}
                  </span>
                </span>
              </CommandItem>
            ))}
          </CommandGroup>
        )}
        {!query && (
          <div className="py-10 text-center text-sm text-muted-foreground">
            Start typing to search posts...
          </div>
        )}
      </CommandList>
    </CommandDialog>
  );
}
